import { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { GridApi, ColumnApi, GetRowIdParams } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { ServerSideGridProps } from '../interfaces/ServerSideGridProps';
import api from '../../reduxStore/route';
export function ServerSideGrid({
  rowDataUrl,
  columnDefs,
  debouncedSearchQuery,
  gridApi,
  columnApi,
  setGridApi,
  setColumnApi,
  ...props
}: ServerSideGridProps) {
  const [internalSearchQuery, setInternalSearchQuery] =
    useState(debouncedSearchQuery);

  const getRowId = (params: GetRowIdParams) => params.data.id;
  const [render, setRender] = useState<number>(0);

  useEffect(() => {
    const handler = setTimeout(() => {
      setInternalSearchQuery(debouncedSearchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [debouncedSearchQuery]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      if (!gridApi || !columnApi) return;

      gridApi.setServerSideDatasource({
        getRows: (params) => {
          const queryParams = {
            searchQuery: internalSearchQuery,
            ...params.request,
          };

          api
            .get(rowDataUrl, {
              params: queryParams,
              signal: controller.signal,
            })
            .then((res: any) => {
              if (res?.data) {
                const { records, totCount } = res.data;
                if (!records?.length) {
                  params.api.showNoRowsOverlay();
                } else {
                  params.api.hideOverlay();
                }
                params.success({
                  rowData: records,
                  rowCount: totCount || 0,
                });
              }
            })
            .catch((err: any) => {
              if (err.name === 'CanceledError' || err.name === 'AbortError') {
                // Request was canceled, do nothing
                return;
              }
              // Handle other errors
              params.success({
                rowData: [],
                rowCount: 0,
              });
            });
        },
      });
    };

    fetchData();

    return () => {
      controller.abort(); // Cancel previous request when internalSearchQuery changes
    };
  }, [gridApi, columnApi, rowDataUrl, internalSearchQuery, render]);

  const onGridReady = (params: { api: GridApi; columnApi: ColumnApi }) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  };
  const onFilterChanged = () => {
    setRender(render + 1);
  };
  // const onSortChanged = () => {
  //   setRender(render + 1);
  // };

  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: 'agTextColumnFilter',
    pagination: true,
    flex: 1,
    minWidth: 150,
    filterParams: {
      trimInput: true,
      suppressAndOrCondition: true,
      buttons: ['reset', 'clear'],
    },
    suppressDragLeaveHidesColumns: false,
    cellClassRules: {
      'ag-filtered-column': (params: any) => {
        const filterModel = params.api.getFilterModel();
        return !!filterModel[params.colDef.field];
      },
    },
  };
  const theme = localStorage.getItem('theme');
  const [darkMode, setDarkMode] = useState<boolean>(
    theme == 'dark' ? true : false
  );
  // const toggleTheme = () => {
  //

  //   setDarkMode(theme == 'dark' ? true : false);
  // };

  //
  return (
    <div
      // className="ag-theme-alpine w-full h-[78vh] p-1 mb-14"
      className={
        darkMode
          ? 'ag-theme-alpine-dark  w-full h-[78vh] p-1 mb-14'
          : 'ag-theme-alpine  w-full h-[78vh] p-1 mb-14'
      }
    >
      {/* <DarkModeToggle toggleTheme={toggleTheme} />{' '} */}
      {/* <Button variant="contained" onClick={applyTransaction}>Add</Button> */}
      <AgGridReact
        getRowId={getRowId}
        columnDefs={columnDefs}
        rowModelType={'serverSide'}
        defaultColDef={defaultColDef}
        onGridReady={onGridReady}
        onFilterChanged={onFilterChanged}
        // onSortChanged={onSortChanged}
        suppressServerSideInfiniteScroll={false}
        animateRows={true}
        pagination={true}
        paginationPageSize={25}
        cacheBlockSize={50}
        rowSelection='single'
        overlayNoRowsTemplate='No rows to show'
        // domLayout={'autoHeight'}
        {...props}
        {...props?.gridOptions}
        suppressDragLeaveHidesColumns={true}
        // rowBuffer={rowBuffer}
        // cacheBlockSize={cacheBlockSize}
      />{' '}
    </div>
  );
}
